import React, { useState, useEffect } from 'react'
import { userList, userProfile, multiplierRequestList, multiplierRequestDetails , submitRequestReponse} from '../../api/users';
import { getDownloadFile, uploadImageAPI, putAPI } from "../../services/ApiService";
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import Pagination from '../Layout/Pagination';
import { DateFunc } from '../../services/Date';

// import Swal from 'sweetalert2';
import { CModal, CModalHeader, CModalTitle, CModalBody } from '@coreui/react';

function Multiplier() {
    useEffect(() => {
        document.title = "Active Panelist - Brand Synergix"
    },);
    const [searchKeyword, setSearchKeyword] = useState();
    const [listType, setListType] = useState("active");
    const [lists, setLists] = useState();
    const [pageInfo, setPagination] = useState({})
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [detail, setDetail] = useState();
    const [formdata, setFormdata] = useState();
    const [visibleDetail, setVisibleDetail] = useState(false);
    const [displayRejectionBox, setdisplayRejectionBox] = useState("none");

    useEffect(() => {
        getList()
    }, [listType]);

    const changePage = (p) => {
        pageInfo.current_page = p;
        getList();
    }

    const getList = async () => {
        if (listType) {
            setSearchKeyword(document.getElementById('searchKeyWord').value);
            let payloadData = {
                listType: listType,
                q: searchKeyword ? searchKeyword : "",
                page: pageInfo.current_page ? pageInfo.current_page : 1,
                recPerPage: 50,
                from: startDate ? Math.floor(new Date(startDate + ' 00:00:00').getTime() / 1000) : "",
                to: endDate ? Math.floor(new Date(endDate + ' 23:59:59').getTime() / 1000) : ""
            }
            let res = await multiplierRequestList({ payload: payloadData });
            if (res.status === 1) {
                setLists(res.payload);
                setPagination(res.paginationInfo);
            } else {
                setLists([])
            }
        }
    }

    const downloadUserData = async () => {
        if (listType) {
            // set search keyword
            setSearchKeyword(document.getElementById('searchKeyWord').value);
            let payloadData = {
                listType: listType,
                q: searchKeyword ? searchKeyword : "",
                page: pageInfo.current_page ? pageInfo.current_page : 0,
                recPerPage: pageInfo.recPerPage ? pageInfo.recPerPage : 50,
                from: startDate ? Math.floor(new Date(startDate + ' 00:00:00').getTime() / 1000) : "",
                to: endDate ? Math.floor(new Date(endDate + ' 23:59:59').getTime() / 1000) : ""
            }

            await getDownloadFile("/user/download/?page=" + payloadData.page + "&recPerPage=" + payloadData.recPerPage + "&q=" + payloadData.q + "&from=" + payloadData.from + "&to=" + payloadData.to + "&listType=" + payloadData.listType, "users_" + Math.floor(new Date().getTime() / 1000));
        }
    };

    const fetchRequestDetails = async (id) => {
        let res = await multiplierRequestDetails(id);
        if (res.status === 1) {
            setDetail(res.payload);
            setVisibleDetail(true);
        }
    }

    const handleChange = async (e) => {
            let file = e.target.files;
            var fileElement = file[0];
            var fileExtension = "";
            if (fileElement.name.lastIndexOf(".") > 0) {
                fileExtension = fileElement.name.substring(fileElement.name.lastIndexOf(".") + 1, fileElement.name.length);
            }
            
                let res = await uploadImageAPI('/upload/common/', file)
                console.log('res', res)
                if (res.status === 1) {
                   
                    setFormdata({
                        ...formdata,
                        responseURL: res.url
                    });
                
                }
        }

    return (
        <div style={{ display: "inline-block", width: "100%" }}>
            <Sidebar />
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12 col-lg-12 col-xl-12 col-md-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">Panelist</li>
                                                <li className="breadcrumb-item active">Active</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className='d-flex justify-content-between align-items-center gap-3'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className="mb-3 row mx-2">
                                        <label htmlFor="Projectdescription" className="form-label mb-0">Search <span className="required_field">*</span></label>
                                        <input type="text" onKeyDown={(e) => setSearchKeyword(e.target.value)} className="form-control" placeholder='Search by name, email, phone . . .' id="searchKeyWord" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="startDate" className="form-label mb-0">From <span className="required_field">*</span></label>
                                        <input type="date" onChange={(e) => setStartDate(e.target.value)} className="form-control" id="startDate" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="endDate" className="form-label mb-0">To <span className="required_field">*</span></label>
                                        <input type="date" onChange={(e) => setEndDate(e.target.value)} className="form-control" id="endDate" />
                                    </div>
                                     <div className="mb-3 d-flex align-items-center">
                                        <button className="btn btn-primary mt-3 d-flex align-items-center gap-2" onClick={() => getList()}>
                                            <i className="mdi mdi-magnify"></i> <span>Go</span>
                                        </button>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center gap-3'>
                                   
                                    <div className="mb-3 d-flex align-items-center">
                                        <button className="btn btn-primary mt-3 d-flex align-items-center gap-2" onClick={() => downloadUserData()}>
                                            <i className="mdi mdi-download"></i> <span>Download</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">
                                        {/* <!-- end card header --> */}
                                        <div className="card-body">
                                            <table className="table table-striped table-hover table_client1" style={{ font: "12px" }}>
                                                <thead>
                                                    <tr className="bg-orange" style={{ color: "black" }}>
                                                        <th scope="col">Sr. no.</th>
                                                        <th scope="col" style={{ textAlign: "left"}}>Request Details</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Client Details</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Requested On</th>
                                                        {/* <th scope="col" style={{ textAlign: "left" }}>Status</th> */}
                                                        <th scope="col" style={{ textAlign: "left" }}>Status</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>More</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-body">
                                                    {lists ? (<>
                                                        {lists?.length > 0 ? (<>
                                                            {lists?.map((row, index) => {
                                                                return (
                                                                    <>
                                                                        <tr
                                                                            key={index + 1}
                                                                            id={row?.ID}
                                                                            style={{ transition: "background 0.2s" }}
                                                                            onMouseOver={e => e.currentTarget.style.background = "#bbb"}
                                                                            onMouseOut={e => e.currentTarget.style.background = ""}>
                                                                            <td>{(pageInfo.current_page - 1) * pageInfo.perPage + ++index}</td>
                                                                            <td style={{ maxWidth: "200px" }}>
                                                                                {row?.requestData && row?.requestData?.length > 0 ? (
                                                                                    <>
                                                                                        {row.requestData.slice(0, 5).map((item, i) => (
                                                                                            <span key={i}>{item.label}{i < Math.min(row.requestData.length, 5) - 1 ? ', ' : ''}</span>
                                                                                        ))}
                                                                                        {row.requestData.length > 5 && <span>...</span>}
                                                                                        &nbsp;
                                                                                        <button
                                                                                            className="btn bg-aaa py-0 px-2"
                                                                                            style={{ fontSize: "18px", verticalAlign: "middle", background: "#eee" }}
                                                                                            title="More"
                                                                                             onClick={() => fetchRequestDetails(row?.ID)}
                                                                                        >
                                                                                            <i className="mdi mdi-dots-horizontal"></i>
                                                                                        </button>
                                                                                    </>
                                                                                ) : null}
                                                                            </td>
                                                                            <td style={{ textAlign: "left" }}>{row?.firstName} <br />{row?.email} <br /> {row?.mobileNumber && row?.mobileNumber !== null && row?.mobileNumber !== "" ? row?.mobileNumber : "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{row?.requestDate}</td>
                                                                            <td style={{ textAlign: "left", position: "relative" }}>
                                                                                <span className={
                                                                                    row?.requestStatus === "pending"
                                                                                        ? "badge bg-warning"
                                                                                        : row?.requestStatus === "processed"
                                                                                            ? "badge bg-success"
                                                                                            : row?.requestStatus === "rejected"
                                                                                                ? "badge bg-danger"
                                                                                                : "badge bg-secondary"
                                                                                }>
                                                                                    {row?.requestStatus}
                                                                                </span>
                                                                                {row?.requestStatus === "rejected" && row?.details ? (
                                                                                    <>
                                                                                        <span
                                                                                            style={{ marginLeft: 6, cursor: "pointer", color: "#dc3545" }}
                                                                                            title={row.details}
                                                                                            onClick={e => {
                                                                                                e.stopPropagation();
                                                                                                const tooltipId = `tooltip-${row.ID}`;
                                                                                                const tooltip = document.getElementById(tooltipId);
                                                                                                if (tooltip) {
                                                                                                    tooltip.style.display = tooltip.style.display === "block" ? "none" : "block";
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <i className="mdi mdi-help-circle-outline"></i>
                                                                                        </span>
                                                                                        <div
                                                                                            id={`tooltip-${row.ID}`}
                                                                                            style={{
                                                                                                display: "none",
                                                                                                position: "absolute",
                                                                                                left: 30,
                                                                                                top: 0,
                                                                                                zIndex: 1000,
                                                                                                background: "#fff",
                                                                                                border: "1px solid #ccc",
                                                                                                borderRadius: 4,
                                                                                                padding: "8px 12px",
                                                                                                minWidth: 180,
                                                                                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                                                                                color: "#333",
                                                                                                fontSize: 13,
                                                                                                whiteSpace: "pre-line"
                                                                                            }}
                                                                                            onClick={e => e.stopPropagation()}
                                                                                        >
                                                                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                                                <span></span>
                                                                                                <button
                                                                                                    style={{
                                                                                                        border: "none",
                                                                                                        background: "transparent",
                                                                                                        fontWeight: "bold",
                                                                                                        fontSize: 16,
                                                                                                        cursor: "pointer",
                                                                                                    }}
                                                                                                    onClick={e => {
                                                                                                        e.stopPropagation();
                                                                                                        const tooltip = document.getElementById(`tooltip-${row.ID}`);
                                                                                                        if (tooltip) tooltip.style.display = "none";
                                                                                                    }}
                                                                                                    aria-label="Close"
                                                                                                >×</button>
                                                                                            </div>
                                                                                            <div style={{ marginTop: 4 }}>{row.details}</div>
                                                                                        </div>
                                                                                    </>
                                                                                ) : null}
                                                                            </td>
                                                                            <td style={{ textAlign: "left" }}>
                                                                                <div className="dropdown d-inline">
                                                                                    <button
                                                                                        className="btn btn-link p-0"
                                                                                        type="button"
                                                                                        id={`dropdownMenuButton${row?.ID}`}
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                        style={{ boxShadow: "none" }}
                                                                                    >
                                                                                        <i className="mdi mdi-dots-vertical" style={{ fontSize: "22px" }}></i>
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${row?.ID}`}>
                                                                                        <li>
                                                                                            <button className="dropdown-item" onClick={() => fetchRequestDetails(row?.ID)}>
                                                                                                <i className="mdi mdi-eye"></i> Manage Request
                                                                                            </button>
                                                                                        </li>
                                                                                        {/* <li>
                                                                                            <button className="dropdown-item" >
                                                                                                <i className="mdi mdi-download"></i> Download Response
                                                                                            </button>
                                                                                        </li>
                                                                                        <li>
                                                                                            <button className="dropdown-item" >
                                                                                                <i className="mdi mdi-upload"></i> Upload Response
                                                                                            </button>
                                                                                        </li> */}
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}
                                                        </>) : (<>
                                                            <tr>
                                                                <td colSpan={9}>No data found</td>
                                                            </tr>
                                                        </>)}
                                                    </>) :
                                                        (<></>)}
                                                </tbody>
                                            </table>
                                            <Pagination pageInfo={pageInfo} changePage={changePage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end row--> */}
                            {/* <!-- end row --> */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}
                </div>
            </div>
            <Footer />
            {visibleDetail ? (<>
                <>
                    {/* <CButton onClick={() => setVisibleDetail(!visibleDetail)}>Launch static backdrop modal</CButton> */}
                    <CModal visible={visibleDetail} backdrop={"static"} size={"xl"} onClose={() => setVisibleDetail(false)}>
                        <CModalHeader style={{ backgroundColor: "#3874ff", paddingBottom: "10px", margin: "-1px" }} closeButton={false}>
                            <CModalTitle style={{ color: "#fff", width: "100%" }}>
                                Request Details
                                <span style={{ float: "right", cursor: "pointer" }} onClick={() => setVisibleDetail(false)}> X </span>
                            </CModalTitle>
                        </CModalHeader>
                        <CModalBody  style={{height:"80vh"}}>
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="row d-flex">
                                        <div className="col-md-4">
                                            <label htmlFor="name" className="form-label">Name/Detail</label><br />
                                            <span> {detail?.firstName} {detail?.lastName}</span>
                                            <br />
                                            <span> {detail?.designation} - {detail?.companyName}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="email" className="form-label">Email</label><br />
                                            <span> {detail?.email}</span>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="phone" className="form-label">Phone:</label><br />
                                            <span> {detail?.mobileNumber}</span>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <label htmlFor="designation" className="form-label">Designation:</label><br />
                                            <span> {detail?.designation} ({detail?.companyName})</span>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="card mb-3 "  style={{height:"400px", overflowY:"auto"}}>
                                        <div className="card-body">
                                            <div className="row d-flex">
                                                <div className="row d-flex">
                                                    {detail?.requestData && detail.requestData.length > 0 ? (
                                                        Object.entries(
                                                            detail.requestData.reduce((acc, item) => {
                                                                if (!acc[item.groupName]) acc[item.groupName] = [];
                                                                acc[item.groupName].push(item.label);
                                                                return acc;
                                                            }, {})
                                                        ).map(([group, labels], idx) => (
                                                            <div className="col-md-12 mb-3" key={group + idx}>
                                                                <strong>{group}</strong>
                                                                <ul style={{ marginBottom: 0 }}>
                                                                    {labels.map((label, i) => (
                                                                        <li key={i}>{label}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12">No request details found.</div>
                                                    )}
                                                    {detail?.requestData && detail.requestData.length > 0 ? (
                                                        Object.entries(
                                                            detail.requestData.reduce((acc, item) => {
                                                                if (!acc[item.groupName]) acc[item.groupName] = [];
                                                                acc[item.groupName].push(item.label);
                                                                return acc;
                                                            }, {})
                                                        ).map(([group, labels], idx) => (
                                                            <div className="col-md-12 mb-3" key={group + idx}>
                                                                <strong>{group}</strong>
                                                                <ul style={{ marginBottom: 0 }}>
                                                                    {labels.map((label, i) => (
                                                                        <li key={i}>{label}</li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12">No request details found.</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row d-flex">
                                        <div className="row d-flex">
                                            <div className="col-md-12 mb-3">
                                                <div className='row'>
                                                    <div className="col-md-6">
                                                        <strong>Request Date</strong>
                                                        <div className="text-muted mb-2">
                                                            {detail?.requestDate}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <strong>Status</strong>
                                                        <div className="text-muted mb-2">
                                                            <span className={
                                                                detail?.requestStatus === "pending"
                                                                    ? "badge bg-warning"
                                                                    : detail?.requestStatus === "processed"
                                                                        ? "badge bg-success"
                                                                        : detail?.requestStatus === "rejected"
                                                                            ? "badge bg-danger"
                                                                            : "badge bg-secondary"
                                                            }>
                                                                {detail?.requestStatus}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <strong>Updated On</strong>
                                                        <div className="text-muted mb-2">
                                                            {detail?.lastUpdatedDate ? detail.lastUpdatedDate : "Not updated yet."}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <strong>Details</strong>
                                                        <div className="text-muted mb-2">
                                                            {detail?.details ? detail.details : "No details provided."}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        {detail?.responseURL && (
                                                            <div className="mb-3">
                                                                <strong>Download File</strong>
                                                                <div>
                                                                    <a
                                                                        href={detail.responseURL}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="btn btn-outline-primary btn-sm mt-1"
                                                                        download
                                                                    >
                                                                        <i className="mdi mdi-download"></i> Download Response File
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 mb-3">
                                            {detail?.requestStatus === "pending" && (
                                                <form
                                                    onSubmit={async (e) => {
                                                        e.preventDefault();
                                                        // handle submit here

                                                        await submitRequestReponse(detail.ID, formdata);
                                                        fetchRequestDetails(detail.ID);
                                                        // setVisibleDetail(false);
                                                        getList();

                                                    }}
                                                >
                                                    <div className="mb-3">
                                                        <label htmlFor="action" className="form-label">Action</label>
                                                        <select
                                                            className="form-select"
                                                            id="action"
                                                            required
                                                            value={formdata?.action || ""}
                                                            onChange={e => setFormdata({ ...formdata, action: e.target.value, file: null, details: "" })}
                                                        >
                                                            <option value="">Select Action</option>
                                                            <option value="processed">Process</option>
                                                            <option value="rejected">Reject</option>
                                                        </select>
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor="details" className="form-label">
                                                            {detail.action === "processed" ? "Processing Details" : "Rejection Reason"}
                                                        </label>
                                                        <textarea
                                                            className="form-control"
                                                            id="details"
                                                            rows={2}
                                                            required
                                                            value={formdata?.details || ""}
                                                            onChange={e => setFormdata({ ...formdata, details: e.target.value })}
                                                            placeholder={detail.action === "processed" ? "Enter processing details..." : "Enter reason for rejection..."}
                                                        />
                                                    </div>
                                                    {formdata?.action === "processed" && (
                                                        // <div className="mb-1">
                                                        //     <label htmlFor="file" className="form-label">Upload File</label>
                                                        //     <input
                                                        //         type="file"
                                                        //         className="form-control"
                                                        //         id="file"
                                                        //         required
                                                        //         onChange={e => setFormdata({ ...formdata, file: e.target.files[0] })}
                                                        //     />
                                                        // </div>
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label className="form-label mb-0">File</label>
                                                                <input type="file" className="form-control" placeholder="type category image" id="file" onChange={handleChange}  />
                                                                {/* <input type="hidden" className="form-control" id="fileURL"  /> */}
                                                                {/* <input type="hidden" className="form-control" id="categoryId"  /> */}

                                                                {/* <button onClick={handleUploadClick}>Upload</button> */}
                                                                {/* <button className="btn btn-primary upload_btn_survey" onClick={browseFile}> <i className="fa fa-upload"></i> Upload Questionnaire  </button> */}
                                                            </div>
                                                        </div>
                                                    )}
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary" 
                                                        disabled={!formdata?.action || !formdata?.details || (formdata?.action === "processed" && !formdata?.responseURL)}
                                                    >
                                                        Submit
                                                    </button>
                                                </form>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CModalBody>
                    </CModal>
                </>
            </>) : (<></>)}
        </div>
    )
}

export default Multiplier;